export const WhiteboardConnector = ({
  connector,
  objects,
  isSelected,
  onSelect,
}) => {
  // For now, render a simple line connector
  // In a full implementation, this would handle:
  // - Auto-snap to object edges
  // - Different connector types (straight, elbow, curved)
  // - Arrowheads
  // - Control points for bending

  const startObj = objects.find(o => o.id === connector.startId);
  const endObj = objects.find(o => o.id === connector.endId);

  if (!startObj || !endObj) return null;

  const startX = startObj.x + startObj.width / 2;
  const startY = startObj.y + startObj.height / 2;
  const endX = endObj.x + endObj.width / 2;
  const endY = endObj.y + endObj.height / 2;

  return (
    <g onClick={onSelect}>
      <line
        x1={startX}
        y1={startY}
        x2={endX}
        y2={endY}
        stroke={connector.stroke || '#64748B'}
        strokeWidth={connector.strokeWidth || 2}
        markerEnd="url(#arrowhead)"
      />
      {isSelected && (
        <>
          <circle cx={startX} cy={startY} r={5} fill="#2563EB" />
          <circle cx={endX} cy={endY} r={5} fill="#2563EB" />
        </>
      )}
    </g>
  );
};
